import { useEffect, useRef, useState } from "react";
import { Send } from "lucide-react";
import StepQuestionStrip from "./StepQuestionStrip";

export default function AssistantComposer({ open, streaming, limitReached, remaining, dailyLimit, showStrip, stepContext, onSend }) {
  const [input, setInput] = useState("");
  const [stripExpanded, setStripExpanded] = useState(true);
  const inputRef = useRef(null);

  useEffect(() => {
    setStripExpanded(true);
  }, [stepContext?.label]);

  useEffect(() => {
    if (open) setTimeout(() => inputRef.current?.focus(), 150);
  }, [open]);

  const submit = (e) => {
    e?.preventDefault();
    if (!input.trim() || streaming || limitReached) return;
    onSend(input);
    setInput("");
  };

  const footer = dailyLimit > 0 ? `${remaining} of ${dailyLimit} questions left today` : "Loading…";

  return (
    <form onSubmit={submit} className="border-t-2 border-[var(--c-border)] bg-[var(--c-surface)] p-3">
      {showStrip && (
        <StepQuestionStrip
          stepContext={stepContext}
          expanded={stripExpanded}
          onToggle={() => setStripExpanded((s) => !s)}
          disabled={streaming || limitReached}
          onSend={onSend}
        />
      )}
      <div className="flex items-end gap-2">
        <textarea
          ref={inputRef}
          data-testid="assistant-input"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) submit(e); }}
          rows={1}
          maxLength={1500}
          disabled={limitReached}
          placeholder={limitReached ? "Daily limit reached — back tomorrow" : "Ask about your Texas LLC…"}
          className="max-h-28 flex-1 resize-none rounded-xl border-2 border-[var(--c-border)] bg-[var(--c-bg)] px-3 py-2 text-sm text-[var(--c-text)] outline-none placeholder:text-[var(--c-muted)] focus:border-[#1E3A8A]"
        />
        <button
          type="submit"
          data-testid="assistant-send"
          disabled={!input.trim() || streaming || limitReached}
          className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl border-2 border-[var(--c-border)] bg-[#1E3A8A] text-white shadow-[2px_2px_0px_var(--c-shadow)] transition-transform hover:-translate-y-0.5 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:translate-y-0"
          aria-label="Send"
        >
          <Send className="h-4 w-4" />
        </button>
      </div>
      <p className="mt-2 text-[10px] text-[var(--c-muted)]">Not legal or tax advice · {footer}</p>
    </form>
  );
}
